import { Badge, Tooltip, useClipboard } from '@chakra-ui/react';
import { PaymasterEndpointDetailResponse } from '@web/dto/paymaster/paymasterEndpointDetailResponse';
import { useCallback, useEffect } from 'react';
import { useInstance } from '../../../domain/hook/useInstance';
import { NotificationService } from '../../../domain/service/NotificationService';
import { UrlService } from '../../../domain/service/UrlService';

interface IProps {
  readonly paymasterEndpoint: PaymasterEndpointDetailResponse;
}

export function PaymasterEndpointUrl(props: IProps) {
  const urlService = useInstance(UrlService);
  const url = urlService.createPaymasterEndpointUrl(props.paymasterEndpoint.accessToken);

  const { onCopy, setValue } = useClipboard(url ?? 'empty');
  const notification = useInstance(NotificationService);

  useEffect(() => {
    setValue(url);
  }, [url, setValue]);

  const copy = useCallback(() => {
    onCopy();
    notification.success('Success', 'Url copied to clipboard');
  }, [onCopy, notification]);

  return (
    <Tooltip label="Click to copy">
      <Badge
        cursor="pointer"
        fontSize="sm"
        onClick={copy}
        textTransform="none"
        whiteSpace="normal"
        wordBreak="break-word"
      >
        {url}
      </Badge>
    </Tooltip>
  );
}
